// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"36":"Panier","389":"404","804":"liste","962":"home"}[chunkId] || chunkId) + "." + {"36":"8fa2f550","277":"7b5d5ab4","389":"3c66d42d","420":"0874ae82","804":"fe0957c8","962":"c71a690c"}[chunkId] + ".js";
};